import { useMemo } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import buildFilterString from '../../helpers/buildFilterString';
import { Products, useGetProductLevel } from 'src/@core/utils/getProductLevel';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';
import { useGetDashboardMetricsQuery } from 'src/queries/services/salesorder';

const RevenueTotalWidget = ({ dashboardDateStrings = [[''], ['']], orderByValue = '' }) => {
  const prod = useGetProductLevel();

  const title = prod === Products.MyPortal ? 'Total Items' : 'Total Items';
  const theme = useTheme();

  const { t } = useVigoTranslation();

  const queryParamFilter = useMemo(() => {
    return buildFilterString(orderByValue, dashboardDateStrings);
  }, [orderByValue, dashboardDateStrings]);

  const { data: dashboardMetrics } = useGetDashboardMetricsQuery({ params: { filter: queryParamFilter } });

  const totalItems = dashboardMetrics?.totalItems ?? 0;

  return (
    <Stack
      direction="column"
      sx={{
        height: '100%',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e1e',
        borderRadius: '5px'
      }}>
      <Box>
        <Typography
          sx={{
            marginTop: '10px',
            marginLeft: '10px',
            textAlign: 'left',
            fontSize: 'clamp(1rem, 10cqw, 1.5rem)',
            fontWeight: '600'
          }}>
          {t(title)}
        </Typography>
      </Box>
      <VigoTypography
        value={totalItems.toFixed(0)}
        className="countWidget__count"
        sx={{
          fontSize: 'clamp(1rem, 30cqw, 3.714rem) !important',
          fontWeight: '500'
        }}
        disableTranslation
      />
    </Stack>
  );
};

export default RevenueTotalWidget;
